import cardRepository from '~/api/cardRepository'
import subscriptionRepository from '~/api/subscriptionRepository'
export default ($axios) => ({
  card: cardRepository($axios, process.env.CARDS_API_URL),
  subscription: subscriptionRepository($axios, process.env.API_URL),
})
